window.addEventListener('load', function () {
  var form = document.querySelector('form#contact_form.contact-form--wizard');
  if (!form) return;

  // DOM references
  var subjectEl       = document.getElementById('contact_subject');
  var detailsStep     = form.querySelector('.cf-step[data-step="2"]');
  var successBox      = document.getElementById('cfFormSuccess');
  var detailsTextarea = form.querySelector('textarea[name="contact[body]"]');
  var summaryEl       = form.querySelector('.cf-summary');
  var issueGroups     = form.querySelectorAll('.cf-issue-group');
  var faqSearchInput  = form.querySelector('.cf-faq-search-input');
  var attachContainer = form.querySelector('.cf-attachments');
  var emailConfirm = form.querySelector('input[name="email_confirm"]');
  var emailInput = form.querySelector('input[name="contact[email]"]');
  var deliveredChecksBlock = form.querySelector('.cf-delivered-no-parcel-checks');
  var delayedDeliveryCheckBlock = form.querySelector('.cf-delayed-delivery-check');
  var orderNumberInput = form.querySelector('input[name="contact[order_number]"]');
  var productNameInput   = form.querySelector('input[name="contact[product_name]"]');
  var productSerialInput = form.querySelector('input[name="contact[product_serial]"]');
  var faultTimingSelect = form.querySelector('select[name="contact[fault_timing]"]');
  var productNameBlock   = form.querySelector('.cf-extra--product_name');
  var productSerialBlock = form.querySelector('.cf-extra--product_serial');
  var faultTimingBlock   = form.querySelector('.cf-extra--fault_timing');
  var returnReasonBlock  = form.querySelector('.cf-extra--return_reason');
  var returnReasonSelect = form.querySelector('select[name="contact[return_reason]"]');
  var addressChangeBlock = form.querySelector('.cf-extra--delivery_address_change');
  var updatedAddress1 = form.querySelector('input[name="contact[updated_address_line1]"]');
  var updatedCity     = form.querySelector('input[name="contact[updated_city]"]');
  var updatedPostcode = form.querySelector('input[name="contact[updated_postcode]"]');
  var showFormBtn       = document.getElementById('showContactForm');
  var formWrapper       = document.getElementById('contactFormWrapper');
  var faqResults        = document.getElementById('faqResults');
  var faqResultsLabel   = document.getElementById('faqResultsLabel');
  var faqIntroText      = document.getElementById('faqIntroText');
  var deliveryReassurance = document.getElementById('deliveryReassurance');
  var faqNoResults      = document.getElementById('faqNoResults');
  var faqSearchMeta     = document.getElementById('faqSearchMeta');
  var faqSearchArea     = document.getElementById('faqSearchArea');
  var faqSearchDropdown = document.getElementById('faqSearchDropdown');
  var faqSearchDropdownMeta = document.getElementById('faqSearchDropdownMeta');
  var faqSearchDropdownList = document.getElementById('faqSearchDropdownList');
  var faqContactTrigger = document.getElementById('faqContactTrigger');
  var helpPageContent   = document.getElementById('helpPageContent');
  var helpBlockLinks    = document.querySelectorAll('.section__nav-blocks [data-help-category]');
  var helpBlocksBar     = document.querySelector('.section__nav-blocks');
  var helpResetWrap     = document.getElementById('helpResetWrap');
  var helpResetBtn      = document.getElementById('helpResetBtn');

  function setAttachmentsMode(mode, customTitle) {
  // mode: 'hide' | 'optional' | 'required'
  if (!attachContainer) return;

  var title = attachContainer.querySelector('.cf-attach-title');
  var inputsWrap = attachContainer.querySelector('.cf-attach-inputs');
  var firstInput = attachContainer.querySelector('input[type="file"]');

  // Clear existing file selections + previews when switching modes
  var preview = attachContainer.querySelector('.cf-attach-preview');
  if (preview) preview.innerHTML = '';
  attachContainer.querySelectorAll('input[type="file"]').forEach(function (fi, idx) {
    if (idx === 0) {
      fi.value = '';
    } else {
      fi.remove();
    }
  });

  if (mode === 'hide') {
    attachContainer.classList.add('cf-hidden');
    if (firstInput) firstInput.removeAttribute('required');
    return;
  }

  attachContainer.classList.remove('cf-hidden');

  // Only override the label when a customTitle is passed (so we don't affect other attachment uses)
  if (title && typeof customTitle === 'string' && customTitle.trim()) {
    title.textContent = customTitle;
  }

  if (firstInput) {
    if (mode === 'required') firstInput.setAttribute('required', 'required');
    else firstInput.removeAttribute('required');
  }

  if (inputsWrap) inputsWrap.style.display = '';
}

function syncEmailConfirmValidity() {
  if (!emailInput || !emailConfirm) return;

  var emailVal = (emailInput.value || '').trim().toLowerCase();
  var confirmVal = (emailConfirm.value || '').trim().toLowerCase();

  if (!confirmVal) {
    emailConfirm.setCustomValidity('');
    return;
  }

  if (emailVal !== confirmVal) {
    emailConfirm.setCustomValidity('Your email addresses don’t match.');
  } else {
    emailConfirm.setCustomValidity('');
  }
}

function syncConditionalFieldSubmission() {
  if (!form) return;

  // Any field inside a hidden conditional block should not be submitted
  form.querySelectorAll('.cf-extra, .cf-delivered-no-parcel-checks, .cf-delayed-delivery-check, .cf-attachments').forEach(function (block) {
    var isHidden = block.classList.contains('cf-hidden');

    block.querySelectorAll('input, select, textarea').forEach(function (field) {
      // Never disable the main message/body field if it happens to be matched in future
      if (field.name === 'contact[body]') return;

      if (isHidden) {
        field.disabled = true;
      } else {
        field.disabled = false;
      }
    });
  });

  // Only the active issue group's hidden input should submit
  form.querySelectorAll('.cf-issue-group').forEach(function (group) {
    var hiddenIssueInput = group.querySelector('input[type="hidden"]');
    if (!hiddenIssueInput) return;

    if (group.classList.contains('cf-hidden')) {
      hiddenIssueInput.disabled = true;
    } else {
      hiddenIssueInput.disabled = false;
    }
  });
}

  // State
  var chosenReason        = null;
  var currentCategory     = null;
  var highlightedFaqBtn   = null;
  var highlightedFaqPanel = null;
  var isUploadingAttachments = false;
  var isFinalNativeSubmit = false;

function resetSubmitLock() {
  isUploadingAttachments = false;
  delete form.dataset.cfSubmitting;
  delete form.dataset.cfFinalSubmit;

  var submitBtn = form.querySelector('.cf-submit');
  if (submitBtn) {
    submitBtn.disabled = false;
    submitBtn.textContent = 'Send message';
  }
}

function scrollToFormTarget() {
  var target =
    form.querySelector('.cf-issue-group.cf-issue-visible:not(.cf-hidden)') ||
    formWrapper;

  if (!target) return;

  var y = target.getBoundingClientRect().top + window.pageYOffset - 180;
  window.scrollTo({
    top: y,
    behavior: 'smooth'
  });
}

function showDetailsStep() {
  if (!detailsStep) return;
  detailsStep.classList.remove('cf-hidden');
  detailsStep.classList.add('cf-visible');
}

function resetTrackingWidgetState() {
  var trackOrder = document.getElementById('cfTrackOrder');
  var trackEmail = document.getElementById('cfTrackEmail');
  var trackError = document.getElementById('cfTrackError');
  var trackResult = document.getElementById('cfTrackResult');

  if (trackOrder) trackOrder.value = '';
  if (trackEmail) trackEmail.value = '';
  if (trackError) trackError.innerHTML = '';

  if (trackResult) {
    trackResult.innerHTML = '';
    trackResult.style.display = 'none';
  }
}

function getCurrentIssueValue() {
  if (!currentCategory) return '';

  var group = form.querySelector('.cf-issue-group--' + currentCategory);
  if (!group) return '';

  var hidden = group.querySelector('input[type="hidden"]');
  return hidden ? (hidden.value || '') : '';
}

function closeFaqSearchDropdown() {
  if (faqSearchDropdown) {
    faqSearchDropdown.classList.add('cf-hidden');
  }

  if (faqSearchDropdownList) {
    faqSearchDropdownList.innerHTML = '';
  }

  if (faqSearchDropdownMeta) {
    faqSearchDropdownMeta.textContent = '';
  }

  if (faqSearchArea) {
    faqSearchArea.classList.remove('is-searching');
  }
}

function resetReturnsSubmitBlock() {
  form.querySelectorAll('.cf-contact-trigger--returns-page').forEach(function (el) {
    el.classList.remove('is-hidden');
    el.classList.remove('cf-hidden');
  });
}

function resetHelpCentreToTopics() {
  currentCategory = null;
  chosenReason = null;
  
  resetTrackingWidgetState();
  resetReturnsSubmitBlock();

  if (faqSearchInput) {
    faqSearchInput.value = '';
  }

  if (faqSearchArea) {
    faqSearchArea.classList.remove('is-searching');
  }

  if (faqResultsLabel) {
    faqResultsLabel.classList.add('cf-hidden');
  }

  if (faqIntroText) {
    faqIntroText.classList.add('cf-hidden');
  }

  if (deliveryReassurance) {
    deliveryReassurance.classList.add('cf-hidden');
  }

  if (faqResults) {
    faqResults.classList.add('cf-hidden');
  }

  if (faqContactTrigger) {
    faqContactTrigger.classList.add('cf-hidden');
  }

  if (formWrapper) {
    formWrapper.classList.add('cf-hidden');
  }

    if (detailsStep) {
    detailsStep.classList.add('cf-hidden');
    detailsStep.classList.remove('cf-visible');
  }

  if (helpBlocksBar) {
    helpBlocksBar.classList.remove('cf-help-blocks-hidden');
  }

  if (helpResetWrap) {
    helpResetWrap.classList.add('cf-hidden');
  }

  DISPLAY_HELPERS.hideHelpPagePanels(helpPageContent);
  FAQ_HELPERS.resetFaqToDefaultState({
    form: form,
    highlightedFaqBtn: highlightedFaqBtn,
    highlightedFaqPanel: highlightedFaqPanel
  });
  highlightedFaqBtn = null;
  highlightedFaqPanel = null;

  form.querySelectorAll('.cf-related-help, .cf-related-help__answer').forEach(function (el) {
    el.remove();
  });

  hideAllIssueGroups();
  clearExtras();
  DISPLAY_HELPERS.setActiveHelpBlock(helpBlockLinks,'');

  form.querySelectorAll('.cf-category-buttons [data-category]').forEach(function (btn) {
    btn.classList.remove('is-active');
  });

  form.querySelectorAll('.cf-reason').forEach(function (btn) {
    btn.classList.remove('is-active', 'cf-hidden');
    btn.style.display = '';
    btn.setAttribute('aria-expanded', 'false');
  });

  form.querySelectorAll('#faqResults .cf-subgroup, #contactFormWrapper .cf-subgroup').forEach(function (sg) {
    sg.classList.add('cf-hidden');
  });

  if (!isApplyingDeepLink) {
    writeDeepLink({ cat: '', issue: '', faq: '' }, 'replace');
  }

  syncConditionalFieldSubmission();
}

if (showFormBtn && formWrapper) {
  showFormBtn.addEventListener('click', function () {
    if (currentCategory === 'warranty') {
      window.location.href = '/pages/help?hc=returns';
      return;
    }

    formWrapper.classList.remove('cf-hidden');

    if (faqContactTrigger) {
      faqContactTrigger.classList.add('is-hidden');
    }

    if (currentCategory) {
      var activeCategoryBtn = form.querySelector('.cf-category-buttons [data-category="' + currentCategory + '"]');

      if (activeCategoryBtn) {
        activeCategoryBtn.click();
      }
    }

    setTimeout(function () {
      scrollToFormTarget();
    }, 180);
  });
}

document.addEventListener('click', function (e) {
  var openFormBtn = e.target.closest('[data-action="open-form"]');
  if (!openFormBtn) return;

  var category = openFormBtn.getAttribute('data-category') || '';
  var formCategory = category;
  var categoryBtn;

  if (formWrapper) {
    formWrapper.classList.remove('cf-hidden');
  }

  if (faqContactTrigger) {
    faqContactTrigger.classList.add('is-hidden');
  }

  if (category) {
    categoryBtn = form.querySelector('.cf-category-buttons [data-category="' + formCategory + '"]');

    if (categoryBtn) {
      categoryBtn.click();

      if (category !== formCategory) {
        currentCategory = category;

        DISPLAY_HELPERS.showHelpPagePanel(helpPageContent, category);
        DISPLAY_HELPERS.setActiveHelpBlock(helpBlockLinks, category);

        if (!isApplyingDeepLink) {
          writeDeepLink({
            cat: category,
            issue: '',
            faq: ''
          }, 'replace');
        }
      }
    }
  }

  setTimeout(function () {
    scrollToFormTarget();
  }, 180);
});

form.addEventListener('click', function (e) {
  var returnsContactBtn = e.target.closest('.cf-returns-contact-btn');
  if (!returnsContactBtn) return;

  if (formWrapper) {
    formWrapper.classList.remove('cf-hidden');
  }

  var returnsCategoryBtn = form.querySelector('.cf-category-buttons [data-category="returns"]');
  if (returnsCategoryBtn) {
    returnsCategoryBtn.click();
  } else {
    showDetailsStep();
  }

  var returnsTrigger = returnsContactBtn.closest('.cf-contact-trigger--returns-page');
  if (returnsTrigger) {
    returnsTrigger.classList.add('is-hidden');
  }

  setTimeout(function () {
    scrollToFormTarget();
  }, 180);
});

if (helpResetBtn) {
  helpResetBtn.addEventListener('click', function () {
    resetHelpCentreToTopics();
  });
}

if (helpBlockLinks && helpBlockLinks.length) {
  helpBlockLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      var cat = link.getAttribute('data-help-category');
      if (!cat) return;

      if (cat === 'returns') {
        resetReturnsSubmitBlock();
      }

      if (cat !== 'tracking') {
        resetTrackingWidgetState();
      }

      if (faqSearchInput) {
        faqSearchInput.value = '';
      }

      if (faqSearchArea) {
        faqSearchArea.classList.remove('is-searching');
      }

      if (faqResultsLabel) {
        if (cat === 'tracking' || cat === 'troubleshooting') {
          faqResultsLabel.classList.add('cf-hidden');
          if (faqIntroText) faqIntroText.classList.add('cf-hidden');
          if (deliveryReassurance) deliveryReassurance.classList.add('cf-hidden');
        } else {
          DISPLAY_HELPERS.setFaqResultsLabel(faqResultsLabel, cat);
          faqResultsLabel.classList.remove('cf-hidden');
          if (faqIntroText) faqIntroText.classList.remove('cf-hidden');

          if (deliveryReassurance) {
            if (cat === 'delivery') deliveryReassurance.classList.remove('cf-hidden');
            else deliveryReassurance.classList.add('cf-hidden');
          }
        }
      }

      if (faqResults) {
        if (cat === 'tracking' || cat === 'troubleshooting') {
          faqResults.classList.add('cf-hidden');
        } else {
          faqResults.classList.remove('cf-hidden');
        }
      }

      if (faqContactTrigger) {
        if (cat === 'tracking' || cat === 'troubleshooting') {
          faqContactTrigger.classList.add('cf-hidden');
        } else {
          faqContactTrigger.classList.remove('cf-hidden');
        }
      }

      if (helpBlocksBar) {
        helpBlocksBar.classList.add('cf-help-blocks-hidden');
      }

      if (helpResetWrap) {
        helpResetWrap.classList.remove('cf-hidden');
      }

      DISPLAY_HELPERS.showHelpPagePanel(helpPageContent,cat);

      setTimeout(function () {
        var activePanel = helpPageContent.querySelector('.cf-help-page-panel[data-page-content="' + cat + '"]');
        if (activePanel) {
          initInfoPanels(activePanel);
        }
      }, 0);

      DISPLAY_HELPERS.setActiveHelpBlock(helpBlockLinks,cat);

      if (!isApplyingDeepLink) {
        writeDeepLink({
          cat: cat,
          issue: '',
          faq: ''
        }, 'push');
      }

      var categoryBtn = form.querySelector('.cf-category-buttons [data-category="' + cat + '"]');

      if (categoryBtn && cat !== 'tracking') {
        categoryBtn.click();
      }

      var faqCol = form.querySelector('.cf-faq-col');
      if (faqCol) {
        requestAnimationFrame(function () {
          faqCol.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });
  });
}

// =====================================================
// Deep linking (hc_cat, hc_issue, hc_faq)
// =====================================================
var isApplyingDeepLink = false;

function readDeepLink() {
  var sp = new URLSearchParams(window.location.search);
  return {
    cat:   (sp.get('hc') || '').trim(),
    issue: (sp.get('i')  || '').trim(),
    faq:   (sp.get('f')  || '').trim()
  };
}

function writeDeepLink(next, mode) {
  var url = new URL(window.location.href);
  var sp = url.searchParams;

  if (next.cat)   sp.set('hc', next.cat);   else sp.delete('hc');
  if (next.issue) sp.set('i',  next.issue); else sp.delete('i');
  if (next.faq)   sp.set('f',  next.faq);   else sp.delete('f');

  url.search = sp.toString();

  if (mode === 'replace') {
    window.history.replaceState({}, '', url.toString());
  } else {
    window.history.pushState({}, '', url.toString());
  }
}

function currentIssueValueForCategory(cat) {
  if (!cat) return '';
  var group = form.querySelector('.cf-issue-group--' + cat);
  if (!group) return '';
  var hidden = group.querySelector('input[type="hidden"]');
  return hidden ? (hidden.value || '') : '';
}

function syncDeepLink(mode) {
  if (isApplyingDeepLink) return;

  writeDeepLink({
    cat: currentCategory || '',
    issue: currentIssueValueForCategory(currentCategory),
    faq: chosenReason || ''
  }, mode || 'push');
}

function applyDeepLinkFromUrl() {
  var dl = readDeepLink();
  if (!dl.cat) return;

  isApplyingDeepLink = true;

  // 1) Click normal form category
  var catBtn = form.querySelector('.cf-category-buttons [data-category="' + dl.cat + '"]');

  if (catBtn) {
    catBtn.click();
  } else {
    var helpBlock = document.querySelector(
      '.section__nav-blocks [data-help-category="' + dl.cat + '"]'
    );

    if (helpBlock) {
      helpBlock.click();

      isApplyingDeepLink = false;

      writeDeepLink({
        cat: dl.cat,
        issue: '',
        faq: ''
      }, 'replace');

      return;
    }
  }

  // 2) Click issue (after category UI renders)
  setTimeout(function () {
    if (dl.issue) {
      var issueBtn = form.querySelector(
        '.cf-issue-group--' + dl.cat + ' .cf-issue[data-issue="' + dl.issue + '"]'
      );

      if (issueBtn) {
        issueBtn.click();

        if (formWrapper) {
          formWrapper.classList.remove('cf-hidden');
        }

        if (faqContactTrigger) {
          faqContactTrigger.classList.add('cf-hidden');
          faqContactTrigger.classList.add('is-hidden');
        }

        showDetailsStep();

        setTimeout(function () {
          scrollToFormTarget();
        }, 180);
      }
    }

    // 3) Open a specific FAQ (after issue highlight logic)
    setTimeout(function () {
      if (dl.faq) {
        var faqBtn = null;

      if (dl.cat === 'returns') {
        faqBtn = form.querySelector(
          '.cf-help-page-panel[data-page-content="returns"] .cf-reason[data-subreason="' + dl.faq + '"]'
        );
      }

      if (!faqBtn) {
        faqBtn = form.querySelector('.cf-reason[data-subreason="' + dl.faq + '"]');
      }
        if (faqBtn) {
          chosenReason = dl.faq;
          if (subjectEl) subjectEl.value = faqBtn.getAttribute('data-subject') || '';
          var faqCtx = {
            faqContent: faqContent,
            highlightedFaqBtn: highlightedFaqBtn,
            highlightedFaqPanel: highlightedFaqPanel
          };
          FAQ_HELPERS.toggleFaq(faqCtx, faqBtn, dl.faq, true, true);
          highlightedFaqBtn = faqCtx.highlightedFaqBtn;
          highlightedFaqPanel = faqCtx.highlightedFaqPanel;

          setTimeout(function () {
            var y = faqBtn.getBoundingClientRect().top + window.pageYOffset - 160;

            window.scrollTo({
              top: y,
              behavior: 'smooth'
            });
          }, 120);

         }
      }

      isApplyingDeepLink = false;
      // keep URL clean/accurate without adding a new history entry
      syncDeepLink('replace');
      document.documentElement.classList.remove('eg-hc-deep-linking');

      document.querySelectorAll('.eg-hc-deep-loader').forEach(function (el) {
        el.remove();
      });
    }, 0);
  }, 0);
}

// Back/forward buttons should restore state
window.addEventListener('popstate', function () {
  applyDeepLinkFromUrl();
});

function triggerFormErrorAnimation() {
  form.classList.add('cf-error');
  setTimeout(function () {
    form.classList.remove('cf-error');
  }, 250);
}

function clearExtras() {
  form.querySelectorAll('.cf-extra').forEach(function (el) {
    el.classList.add('cf-hidden');
  });
}

function applyExtras(extrasString) {
  clearExtras();
  if (!extrasString) return;
  extrasString
    .split(',')
    .map(function (s) { return s.trim(); })
    .forEach(function (key) {
      if (!key) return;
      var block = form.querySelector('.cf-extra--' + key.replace(/[^a-z0-9_]/gi, ''));
      if (block) block.classList.remove('cf-hidden');
    });
}

function applyExtrasForCategory(cat) {
  applyExtras(categoryExtras[cat] || '');
}

function hideAllIssueGroups() {
  issueGroups.forEach(function (g) {
    g.classList.add('cf-hidden');
    g.classList.remove('cf-issue-visible');

    g.querySelectorAll('.cf-issue').forEach(function (btn) {
      btn.classList.remove('is-active');
    });

    var notice = g.querySelector('.cf-issue-notice');
    var noticeText = g.querySelector('.cf-issue-notice__text');
    if (notice) {
      notice.classList.add('cf-hidden');
      notice.classList.remove('is-visible');
    }
    if (noticeText) noticeText.textContent = '';

    var hidden = g.querySelector('input[type="hidden"]');
    if (hidden) hidden.value = '';
  });
}


  var HC_DATA = window.EG_HELP_CENTRE_DATA || {};

  var categoryLabels = HC_DATA.categoryLabels || {};
  var categoryExtras = HC_DATA.categoryExtras || {};
  var FAQ_LIMIT = HC_DATA.FAQ_LIMIT || 7;
  var SEARCH_RESULTS_LIMIT = HC_DATA.SEARCH_RESULTS_LIMIT || 6;
  var faqRegistry = HC_DATA.faqRegistry || {};
  var FAQ_SEARCH_KEYWORDS = HC_DATA.FAQ_SEARCH_KEYWORDS || {};
  var issueCopy = HC_DATA.issueCopy || {};
  var detailsPlaceholder = HC_DATA.detailsPlaceholder || {};
  var issueToFaq = HC_DATA.issueToFaq || {};
  var faqContent = HC_DATA.faqContent || {};
  var FAQ_HELPERS = window.EG_HELP_CENTRE_FAQ || {};
  var ISSUE_HELPERS = window.EG_HELP_CENTRE_ISSUES || {};
  var UPLOAD_HELPERS = window.EG_HELP_CENTRE_UPLOADS || {};
  var DISPLAY_HELPERS = window.EG_HELP_CENTRE_DISPLAY || {};
  var SEARCH_UI_HELPERS = window.EG_HELP_CENTRE_SEARCH_UI || {};

if (successBox && !successBox.classList.contains('cf-hidden')) {
  if (formWrapper) {
    formWrapper.classList.remove('cf-hidden');
  }

  if (detailsStep) {
    detailsStep.classList.add('cf-hidden');
    detailsStep.classList.remove('cf-visible');
  }

  setTimeout(function () {
    successBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    successBox.focus();
  }, 120);
}

function updateHelpfulButtonLabels(panel, cat) {
  if (!panel || cat !== 'returns') return;

  var noBtn = panel.querySelector('.cf-faq-helpful__btn--no');
  if (noBtn) {
    noBtn.textContent = 'No, I still need help';
  }
}

function getFaqRegistryItem(subreason) {
  if (!subreason) return null;

  var found = null;

  Object.keys(faqRegistry).some(function (category) {
    var items = faqRegistry[category] || [];

    return items.some(function (item) {
      if (item.subreason === subreason) {
        found = Object.assign({ category: category }, item);
        return true;
      }

      return false;
    });
  });

  return found;
}

 function getCategoryLabel(cat) {
    if (!cat) return '';
    return categoryLabels[cat] ||
      (cat.charAt(0).toUpperCase() + cat.slice(1));
  }

  function updateDetailsPlaceholder(cat, issueKey) {
    if (!detailsTextarea) return;
    var phGroup = detailsPlaceholder[cat];
    var ph = phGroup && phGroup[issueKey] ? phGroup[issueKey] : 'Details';
    detailsTextarea.placeholder = ph;
  }

  // CATEGORY SELECT
  form.querySelectorAll('.cf-category-buttons [data-category]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var currentCat = btn.getAttribute('data-category');
      currentCategory = currentCat;
      var suppressCategoryFaqUi =
      currentCat === 'returns' ||
      currentCat === 'tracking' ||
      currentCat === 'troubleshooting';

      if (successBox) {
        successBox.classList.add('cf-hidden');
      }

      FAQ_HELPERS.resetAllFaqPanels({
        form: form,
        highlightedFaqBtn: highlightedFaqBtn,
        highlightedFaqPanel: highlightedFaqPanel
      });
      highlightedFaqBtn = null;
      highlightedFaqPanel = null;

      // REMOVE all global search hiding
        form.querySelectorAll('.cf-reason').forEach(function (faqBtn) {
            faqBtn.classList.remove('cf-hidden');
        });

      // Enable search when category selected
      if (faqSearchInput) {
        faqSearchInput.removeAttribute('disabled');
        faqSearchInput.value = '';
      }

      chosenReason = null;

      if (faqSearchArea) {
        faqSearchArea.classList.remove('is-searching');
      }

      if (faqResultsLabel) {
        if (suppressCategoryFaqUi) {
          faqResultsLabel.classList.add('cf-hidden');
        } else {
          DISPLAY_HELPERS.setFaqResultsLabel(faqResultsLabel, currentCat);
          faqResultsLabel.classList.remove('cf-hidden');
        }
      }

      if (faqIntroText) {
        if (suppressCategoryFaqUi) {
          faqIntroText.classList.add('cf-hidden');
        } else {
          if (currentCat === 'orders') {
            faqIntroText.textContent = 'Most ordering questions are about changes, cancellations, payment holds or dispatch timing — check these first before contacting support.';
          } else {
            faqIntroText.textContent = 'Most queries are resolved here before you need to contact support.';
          }

          faqIntroText.classList.remove('cf-hidden');
        }
      }

      if (deliveryReassurance) {
        if (currentCat === 'delivery') deliveryReassurance.classList.remove('cf-hidden');
        else deliveryReassurance.classList.add('cf-hidden');
      }

      if (faqResults) {
        if (suppressCategoryFaqUi) {
          faqResults.classList.add('cf-hidden');
        } else {
          faqResults.classList.remove('cf-hidden');
        }
      }

      if (faqContactTrigger) {
        if (suppressCategoryFaqUi) {
          faqContactTrigger.classList.add('cf-hidden');
        } else {
          faqContactTrigger.classList.remove('cf-hidden');
        }
      }

      if (showFormBtn) {
        if (currentCat === 'warranty') {
          showFormBtn.textContent = 'View returns & fault support';
        } else {
          showFormBtn.textContent = 'Contact Support';
        }
      }

      if (helpBlocksBar) {
        helpBlocksBar.classList.add('cf-help-blocks-hidden');
      }

      if (helpResetWrap) {
        helpResetWrap.classList.remove('cf-hidden');
      }

      DISPLAY_HELPERS.showHelpPagePanel(helpPageContent, currentCat);

      setTimeout(function () {
        var activePanel = helpPageContent.querySelector('.cf-help-page-panel[data-page-content="' + currentCat + '"]');
        if (activePanel) {
          initInfoPanels(activePanel);
        }
      }, 0);

      DISPLAY_HELPERS.setActiveHelpBlock(helpBlockLinks, currentCat);

      form.querySelectorAll('.cf-reason').forEach(function (b) {
        b.classList.remove('is-active');
      });

      applyExtrasForCategory(currentCat);

      // Active state
      form.querySelectorAll('.cf-category-buttons [data-category]').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });

      // Show relevant subgroup
      form.querySelectorAll('#faqResults .cf-subgroup, #contactFormWrapper .cf-subgroup').forEach(function (sg) {
        sg.classList.add('cf-hidden');
      });

      // remove all view-more/less blocks
      form.querySelectorAll('.cf-faq-controls').forEach(function(ctrl){
        ctrl.remove();
      });

      form.querySelectorAll('.cf-reason').forEach(f => f.style.display = '');
      var subgroup = form.querySelector('.cf-subgroup--' + currentCat);
      if (subgroup) {
        subgroup.classList.remove('cf-hidden');
        FAQ_HELPERS.applyFaqLimit({
          form: form,
          faqSearchInput: faqSearchInput,
          FAQ_LIMIT: FAQ_LIMIT
        });
      }

      // Deep link: step 1 (category only) – clear issue+faq
      if (!isApplyingDeepLink) {
        chosenReason = null;
        writeDeepLink({ cat: currentCategory, issue: '', faq: '' }, 'push');
      }

      // Issue group
      hideAllIssueGroups();

      var issueGroup = form.querySelector('.cf-issue-group--' + currentCat);
      if (issueGroup) {
        issueGroup.classList.remove('cf-hidden');
        void issueGroup.offsetWidth;
        issueGroup.classList.add('cf-issue-visible');

        if (detailsStep) {
          detailsStep.classList.add('cf-hidden');
          detailsStep.classList.remove('cf-visible');
        }
      } else {
        // Category with no second question → show details
        showDetailsStep();
      }
      syncConditionalFieldSubmission();
    });
  });

  // FAQ BUTTON CLICK (accordion)
  form.querySelectorAll('.cf-reason').forEach(function (btn) {
    btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') || 'false');

    btn.addEventListener('click', function () {
      var subject = btn.getAttribute('data-subject') || '';
      chosenReason = btn.getAttribute('data-subreason') || null;
      if (subjectEl) subjectEl.value = subject;

      // Deep link: step 3 (category + issue + faq)
      syncDeepLink('push');

      // toggleFaq handles open/close; highlight only if already recommended
      var faqCtx = {
        faqContent: faqContent,
        highlightedFaqBtn: highlightedFaqBtn,
        highlightedFaqPanel: highlightedFaqPanel
      };
      FAQ_HELPERS.toggleFaq(faqCtx, btn, chosenReason, null, btn === highlightedFaqBtn);
      highlightedFaqBtn = faqCtx.highlightedFaqBtn;
      highlightedFaqPanel = faqCtx.highlightedFaqPanel;

      updateHelpfulButtonLabels(highlightedFaqPanel, currentCategory);
    });
  });

    form.addEventListener('click', function (e) {
    var yesBtn = e.target.closest('.cf-faq-helpful__btn--yes');
    var noBtn = e.target.closest('.cf-faq-helpful__btn--no');

    if (yesBtn) {
      e.preventDefault();

      var helpfulBlock = yesBtn.closest('.cf-faq-helpful');
      if (!helpfulBlock) return;

      helpfulBlock.innerHTML =
        '<p class="cf-faq-helpful__resolved">Great — glad this helped 👍</p>';

      var yesPanel = helpfulBlock.closest('.cf-faq-inline');
      if (yesPanel && window.EG_HELP_CENTRE_ACCORDION && window.EG_HELP_CENTRE_ACCORDION.sync) {
        window.EG_HELP_CENTRE_ACCORDION.sync(yesPanel);
      }

      return;
    }

    if (noBtn) {
      e.preventDefault();

      var noHelpfulBlock = noBtn.closest('.cf-faq-helpful');
      var panel = noBtn.closest('.cf-faq-inline');
      if (!panel) return;

      if (panel.nextElementSibling && panel.nextElementSibling.classList.contains('cf-related-help')) {
        return;
      }

      var currentFaqBtn = panel.previousElementSibling;
      if (!currentFaqBtn || !currentFaqBtn.classList.contains('cf-reason')) return;

      var currentSubreason = currentFaqBtn.getAttribute('data-subreason') || '';
      var cat = currentCategory;

      if (!cat) {
        var parentGroup = currentFaqBtn.closest('.cf-subgroup');
        var catMatch = parentGroup ? parentGroup.className.match(/cf-subgroup--([a-z]+)/) : null;
        cat = catMatch ? catMatch[1] : '';
      }

      if (cat === 'returns' || currentFaqBtn.closest('.cf-returns-page')) {
        currentCategory = 'returns';
        resetReturnsSubmitBlock();

        if (noHelpfulBlock) {
          noHelpfulBlock.innerHTML =
            '<p class="cf-faq-helpful__resolved">No problem — if you still need to return an item, use the return request button below.</p>';
        }

        if (faqContactTrigger) {
          faqContactTrigger.classList.add('cf-hidden');
          faqContactTrigger.classList.add('is-hidden');
        }

        return;
      }

            var isCategoryHelpPage =
        faqResultsLabel &&
        faqResultsLabel.textContent.trim().toLowerCase().indexOf('common ') === 0;

      if (isCategoryHelpPage) {
        currentCategory = cat;

        if (noHelpfulBlock) {
          noHelpfulBlock.innerHTML =
            '<p class="cf-faq-helpful__resolved">No problem — check the full help below.</p>';
        }

        DISPLAY_HELPERS.setActiveHelpBlock(helpBlockLinks, cat);
        DISPLAY_HELPERS.showHelpPagePanel(helpPageContent, cat);

        if (helpPageContent) {
          helpPageContent.classList.remove('cf-hidden');
        }

        if (cat === 'returns') {
          resetReturnsSubmitBlock();

          if (noHelpfulBlock) {
            noHelpfulBlock.innerHTML =
              '<p class="cf-faq-helpful__resolved">No problem — if you still need to return an item, use the return request button below.</p>';
          }

          if (faqContactTrigger) {
            faqContactTrigger.classList.add('cf-hidden');
            faqContactTrigger.classList.add('is-hidden');
          }

          return;
        }

        if (faqContactTrigger) {
          faqContactTrigger.classList.remove('cf-hidden');
          faqContactTrigger.classList.remove('is-hidden');
        }

        setTimeout(function () {
          var activePanel = helpPageContent.querySelector('.cf-help-page-panel[data-page-content="' + cat + '"]');
          if (activePanel) {
            initInfoPanels(activePanel);
            activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 0);

        return;
      }

      if (faqResults && faqResults.classList.contains('is-enter-search-results')) {
        currentCategory = cat;

        DISPLAY_HELPERS.setActiveHelpBlock(helpBlockLinks, cat);
        DISPLAY_HELPERS.showHelpPagePanel(helpPageContent, cat);

        if (helpPageContent) {
          helpPageContent.classList.remove('cf-hidden');
        }

        if (faqContactTrigger) {
          faqContactTrigger.classList.remove('cf-hidden');
          faqContactTrigger.classList.remove('is-hidden');
        }

        setTimeout(function () {
          var activePanel = helpPageContent.querySelector('.cf-help-page-panel[data-page-content="' + cat + '"]');
          if (activePanel) {
            initInfoPanels(activePanel);
            activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 0);

        return;
      }

      var related = (faqRegistry[cat] || [])
        .map(function (item) {
          var score = 0;

          if (item.subreason === currentSubreason) return null;

          var currentItem = getFaqRegistryItem(currentSubreason);
          if (!currentItem) return { item: item, score: 0 };

          var q1 = (currentItem.question || '').toLowerCase();
          var q2 = (item.question || '').toLowerCase();

          // basic keyword overlap scoring
          q1.split(' ').forEach(function (word) {
            if (word.length > 3 && q2.includes(word)) {
              score += 2;
            }
          });

          // same subject boost
          if (item.subject && currentItem.subject && item.subject === currentItem.subject) {
            score += 3;
          }

          return { item: item, score: score };
        })
        .filter(Boolean)
        .sort(function (a, b) {
          return b.score - a.score;
        })
        .slice(0, 3)
        .map(function (entry) {
          return entry.item;
        });

      var relatedHtml =
        '<div class="cf-related-help">' +
          '<p class="cf-related-help__title">Still need help? Try these first:</p>';

      related.forEach(function (item, index) {
        relatedHtml +=
          '<button type="button" class="cf-related-help__item' + (index === 0 ? ' cf-related-help__item--top' : '') + '" data-related-faq="' + item.subreason + '">' +
            (index === 0 ? '<span class="cf-related-help__badge">Top recommendation</span>' : '') +
            '<span class="cf-related-help__question">' + item.question + '</span>' +
          '</button>';
      });

      relatedHtml +=
          '<div class="cf-related-help__actions">' +
            '<button type="button" class="cf-related-help__view-category" data-category="' + cat + '">View all ' + getCategoryLabel(cat) + ' help</button>' +
            '<button type="button" class="cf-related-help__contact">Contact support</button>' +
          '</div>' +
        '</div>';

      panel.insertAdjacentHTML('afterend', relatedHtml);

      if (noHelpfulBlock) {
        noHelpfulBlock.innerHTML =
          '<p class="cf-faq-helpful__resolved">No problem — here are the next best options.</p>';
      }

      if (window.EG_HELP_CENTRE_ACCORDION && window.EG_HELP_CENTRE_ACCORDION.sync) {
        window.EG_HELP_CENTRE_ACCORDION.sync(panel);
      }

      return;
    }
  });

form.addEventListener('click', function (e) {
  var categoryBtn = e.target.closest('.cf-related-help__view-category');
  if (!categoryBtn) return;

  e.preventDefault();

  var cat = categoryBtn.getAttribute('data-category');
  if (!cat) return;

  currentCategory = cat;

  if (helpBlocksBar) {
    helpBlocksBar.classList.add('cf-help-blocks-hidden');
  }

  if (helpResetWrap) {
    helpResetWrap.classList.remove('cf-hidden');
  }

  if (faqResults) {
    faqResults.classList.remove('cf-hidden');
  }

  if (faqContactTrigger) {
    faqContactTrigger.classList.add('cf-hidden');
  }

  DISPLAY_HELPERS.setActiveHelpBlock(helpBlockLinks, cat);
  DISPLAY_HELPERS.showHelpPagePanel(helpPageContent, cat);

  setTimeout(function () {
    var activePanel = helpPageContent.querySelector('.cf-help-page-panel[data-page-content="' + cat + '"]');
    if (activePanel) {
      initInfoPanels(activePanel);
    }
  }, 0);

  if (!isApplyingDeepLink) {
    writeDeepLink({
      cat: cat,
      issue: '',
      faq: chosenReason || ''
    }, 'push');
  }

  if (helpPageContent) {
    helpPageContent.classList.remove('cf-hidden');
  }
});

form.addEventListener('click', function (e) {
  var moreBtn = e.target.closest('.cf-related-help__more');
  if (!moreBtn) return;

  e.preventDefault();

  var container = moreBtn.closest('.cf-related-help');
  if (!container) return;

  if (container.querySelector('.cf-related-help__final')) {
    return;
  }

  var panel = container.closest('.cf-faq-inline');
  var faqBtn = panel ? panel.previousElementSibling : null;
  var parentGroup = faqBtn ? faqBtn.closest('.cf-subgroup') : null;
  var catMatch = parentGroup ? parentGroup.className.match(/cf-subgroup--([a-z]+)/) : null;
  var cat = currentCategory || (catMatch ? catMatch[1] : '');

  var categoryLabel = cat ? getCategoryLabel(cat) : 'this topic';

  var finalHtml =
    '<div class="cf-related-help__final">' +
      '<p class="cf-related-help__final-text">' +
        'Most queries about ' + categoryLabel + ' are resolved in the help above.' +
        '<br><br>' +
        'Please check the related help before contacting support.' +
      '</p>' +
      '<label class="cf-related-help__confirm">' +
        '<input type="checkbox" class="cf-related-help__confirm-checkbox">' +
        ' I still need help and have checked the information above' +
      '</label>' +
      '<button type="button" class="cf-related-help__contact" disabled>Contact support</button>' +
    '</div>';

  moreBtn.classList.add('cf-hidden');
  container.insertAdjacentHTML('beforeend', finalHtml);

  if (window.EG_HELP_CENTRE_ACCORDION && window.EG_HELP_CENTRE_ACCORDION.sync && panel) {
    window.EG_HELP_CENTRE_ACCORDION.sync(panel);
  }
});

form.addEventListener('click', function (e) {
  var relatedBtn = e.target.closest('.cf-related-help__item');
  if (!relatedBtn) return;

  e.preventDefault();

  var subreason = relatedBtn.getAttribute('data-related-faq');
  if (!subreason || !faqContent[subreason]) return;

  var existingPanel = relatedBtn.nextElementSibling;
  if (existingPanel && existingPanel.classList.contains('cf-related-help__answer')) {
    existingPanel.remove();
    relatedBtn.classList.remove('is-open');
    return;
  }

  relatedBtn.classList.add('is-open');

  relatedBtn.insertAdjacentHTML(
    'afterend',
    '<div class="cf-related-help__answer">' + faqContent[subreason] + '</div>'
  );
});

form.addEventListener('click', function (e) {
  var searchItem = e.target.closest('.cf-faq-search-dropdown__item');
  if (!searchItem) return;

  e.preventDefault();

  if (faqResults) {
    faqResults.classList.remove('is-enter-search-results');
  }

  var subreason = searchItem.getAttribute('data-search-faq') || '';
  var cat = searchItem.getAttribute('data-search-category') || '';
  if (!subreason || !cat) return;

  closeFaqSearchDropdown();

  if (faqSearchInput) {
    faqSearchInput.value = '';
  }

  currentCategory = cat;
  chosenReason = subreason;

  if (helpBlocksBar) {
    helpBlocksBar.classList.add('cf-help-blocks-hidden');
  }

  if (helpResetWrap) {
    helpResetWrap.classList.remove('cf-hidden');
  }

  if (faqResultsLabel) {
    faqResultsLabel.textContent = 'Search result';
    faqResultsLabel.classList.remove('cf-hidden');
  }

  if (faqIntroText) {
    faqIntroText.textContent = 'Review this answer first. If it does not help, we will show related help before opening the contact form.';
    faqIntroText.classList.remove('cf-hidden');
  }

  if (faqNoResults) {
    faqNoResults.classList.add('cf-hidden');
  }

  if (faqResults) {
    faqResults.classList.remove('cf-hidden');
  }

  if (faqContactTrigger) {
    faqContactTrigger.classList.add('cf-hidden');
  }

  DISPLAY_HELPERS.setActiveHelpBlock(helpBlockLinks, cat);
  DISPLAY_HELPERS.hideHelpPagePanels(helpPageContent);

  form.querySelectorAll('#faqResults .cf-subgroup').forEach(function (sg) {
    sg.classList.add('cf-hidden');
  });

  form.querySelectorAll('#faqResults .cf-reason').forEach(function (btn) {
    btn.classList.remove('is-active');
    btn.classList.add('cf-hidden');
    btn.style.display = 'none';
    btn.setAttribute('aria-expanded', 'false');
  });

  form.querySelectorAll('.cf-faq-inline, .cf-related-help, .cf-related-help__answer').forEach(function (el) {
    el.remove();
  });

  var subgroup = form.querySelector('#faqResults .cf-subgroup--' + cat);
  if (subgroup) {
    subgroup.classList.remove('cf-hidden');
  }

  var targetBtn = form.querySelector('#faqResults .cf-reason[data-subreason="' + subreason + '"]');
  if (!targetBtn) return;

  targetBtn.classList.remove('cf-hidden');
  targetBtn.style.display = '';
  targetBtn.classList.add('is-active');

  if (subjectEl) {
    subjectEl.value = targetBtn.getAttribute('data-subject') || '';
  }

  if (!isApplyingDeepLink) {
    writeDeepLink({
      cat: cat,
      issue: '',
      faq: subreason
    }, 'push');
  }

  var faqCtx = {
    faqContent: faqContent,
    highlightedFaqBtn: highlightedFaqBtn,
    highlightedFaqPanel: highlightedFaqPanel
  };

  FAQ_HELPERS.toggleFaq(faqCtx, targetBtn, subreason, true, false);
  highlightedFaqBtn = faqCtx.highlightedFaqBtn;
  highlightedFaqPanel = faqCtx.highlightedFaqPanel;

  var faqCol = form.querySelector('.cf-faq-col');
  if (faqCol) {
    requestAnimationFrame(function () {
      faqCol.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
});

form.addEventListener('click', function (e) {
  var contactBtn = e.target.closest('.cf-related-help__contact');
  if (!contactBtn) return;

  e.preventDefault();

  var relatedBlock = contactBtn.closest('.cf-related-help');
  var panel = relatedBlock ? relatedBlock.previousElementSibling : contactBtn.closest('.cf-faq-inline');
  var faqBtn = panel ? panel.previousElementSibling : null;
  var parentGroup = faqBtn ? faqBtn.closest('.cf-subgroup') : null;
  var catMatch = parentGroup ? parentGroup.className.match(/cf-subgroup--([a-z]+)/) : null;
  var cat = currentCategory || (catMatch ? catMatch[1] : '');
  var subreason = faqBtn ? faqBtn.getAttribute('data-subreason') : '';
  var question = faqBtn ? faqBtn.textContent.trim() : '';

  if (!cat) return;

  if (formWrapper) {
    formWrapper.classList.remove('cf-hidden');
  }

  if (faqContactTrigger) {
    faqContactTrigger.classList.add('is-hidden');
  }

  var categoryBtn = form.querySelector('.cf-category-buttons [data-category="' + cat + '"]');

  if (categoryBtn) {
    categoryBtn.click();
  }

  setTimeout(function () {
    var issueKey = subreason ? issueToFaq[subreason] : '';
    var issueBtn = issueKey
      ? form.querySelector('.cf-issue-group--' + cat + ' .cf-issue[data-issue="' + issueKey + '"]')
      : null;

    if (issueBtn) {
      issueBtn.click();
    } else {
      showDetailsStep();
    }

    var contextField = document.getElementById('contact_help_context');
    var selectedIssueValue = getCurrentIssueValue();

    if (contextField && question) {
      contextField.value =
        'Category: ' + getCategoryLabel(cat) +
        ' | FAQ viewed: ' + question +
        ' | Issue: ' + (selectedIssueValue || 'Not selected');
    }

    scrollToFormTarget();
  }, 150);
});

form.addEventListener('change', function (e) {
  var checkbox = e.target.closest('.cf-related-help__confirm-checkbox');
  if (!checkbox) return;

  var container = checkbox.closest('.cf-related-help__final');
  if (!container) return;

  var btn = container.querySelector('.cf-related-help__contact');
  if (!btn) return;

  btn.disabled = !checkbox.checked;
});

  // GLOBAL FAQ SEARCH
if (faqSearchInput) {

faqSearchInput.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter') return;

  e.preventDefault();
  e.stopPropagation();

  if (!faqSearchDropdownList || !faqResults) return;

  var items = Array.prototype.slice.call(
    faqSearchDropdownList.querySelectorAll('.cf-faq-search-dropdown__item')
  );

  if (!items.length) return;

  closeFaqSearchDropdown();

  if (helpBlocksBar) {
    helpBlocksBar.classList.add('cf-help-blocks-hidden');
  }

  if (helpResetWrap) {
    helpResetWrap.classList.remove('cf-hidden');
  }

  if (faqResultsLabel) {
    faqResultsLabel.textContent = 'Search results';
    faqResultsLabel.classList.remove('cf-hidden');
  }

  if (faqIntroText) {
    faqIntroText.textContent = 'Choose the closest question below. If it does not help, we will show related help before opening the contact form.';
    faqIntroText.classList.remove('cf-hidden');
  }

  if (faqNoResults) {
    faqNoResults.classList.add('cf-hidden');
  }

  if (faqResults) {
    faqResults.classList.remove('cf-hidden');
    faqResults.classList.add('is-enter-search-results');
  }

  DISPLAY_HELPERS.hideHelpPagePanels(helpPageContent);
  DISPLAY_HELPERS.setActiveHelpBlock(helpBlockLinks, '');

  if (faqContactTrigger) {
    faqContactTrigger.classList.add('cf-hidden');
  }

  form.querySelectorAll('#faqResults .cf-subgroup').forEach(function (sg) {
    sg.classList.remove('cf-hidden');
  });

  form.querySelectorAll('#faqResults .cf-reason').forEach(function (btn) {
    btn.classList.add('cf-hidden');
    btn.style.display = 'none';
    btn.classList.remove('is-active');
    btn.setAttribute('aria-expanded', 'false');
  });

  form.querySelectorAll('.cf-faq-inline, .cf-related-help, .cf-related-help__answer').forEach(function (el) {
    el.remove();
  });

  items.forEach(function (item) {
    var subreason = item.getAttribute('data-search-faq') || '';
    if (!subreason) return;

    var btn = form.querySelector('#faqResults .cf-reason[data-subreason="' + subreason + '"]');
    if (!btn) return;

    var group = btn.closest('.cf-subgroup');
    if (group) {
      group.classList.remove('cf-hidden');
    }

    btn.classList.remove('cf-hidden');
    btn.style.display = '';
  });
});

  var faqSearchTimer;

  faqSearchInput.addEventListener('input', function () {
    clearTimeout(faqSearchTimer);

    faqSearchTimer = setTimeout(function () {
      var term = faqSearchInput.value.trim().toLowerCase();

    // reset click handlers before applying search behaviour
    form.querySelectorAll('.cf-reason').forEach(function (btn) {
      btn.onclick = null;
    });

    if (term.length > 0) {
      if (faqSearchArea) {
        faqSearchArea.classList.add('is-searching');
      }

      if (formWrapper) {
        formWrapper.classList.add('cf-hidden');
      }

      if (detailsStep) {
        detailsStep.classList.add('cf-hidden');
        detailsStep.classList.remove('cf-visible');
      }

      hideAllIssueGroups();
      clearExtras();
      syncConditionalFieldSubmission();

      if (faqNoResults) {
        faqNoResults.classList.add('cf-hidden');
      }

      if (faqSearchMeta) {
        faqSearchMeta.textContent = '';
        faqSearchMeta.classList.add('cf-hidden');
      }

      var allFaqButtons = Array.prototype.slice.call(form.querySelectorAll('.cf-reason'));
      var matchedButtons = allFaqButtons
        .map(function (btn, index) {
          return {
            btn: btn,
            score: (function () {
              var baseScore = FAQ_HELPERS.getFaqSearchScore(btn, term, FAQ_SEARCH_KEYWORDS);

              var subreason = btn.getAttribute('data-subreason');
              var item = getFaqRegistryItem(subreason);

              if (!item) return baseScore;

              var extraScore = 0;
              var t = term.toLowerCase();

              if (item.question && item.question.toLowerCase().includes(t)) {
                extraScore += 3;
              }

              if (item.subject && item.subject.toLowerCase().includes(t)) {
                extraScore += 2;
              }

              return baseScore + extraScore;
            })(),
            index: index
          };
        })
        .filter(function (item) {
          return item.score > 0;
        })
        .sort(function (a, b) {
          if (b.score !== a.score) return b.score - a.score;
          return a.index - b.index;
        });

      var seenSubreasons = {};
      var dedupedMatches = matchedButtons.filter(function (item) {
        var subreason = item.btn.getAttribute('data-subreason') || '';
        if (!subreason) return false;

        if (seenSubreasons[subreason]) {
          return false;
        }

        seenSubreasons[subreason] = true;
        return true;
      });

      var displayedMatches = dedupedMatches.slice(0, SEARCH_RESULTS_LIMIT);
      var visibleCount = displayedMatches.length;

      if (faqSearchDropdownList) {
        faqSearchDropdownList.innerHTML = '';

        displayedMatches.forEach(function (item) {
          var btn = item.btn;
          var subreason = btn.getAttribute('data-subreason') || '';
          var registryItem = getFaqRegistryItem(subreason);
          if (!registryItem) return;

          var row = document.createElement('button');
          row.type = 'button';
          row.className = 'cf-faq-search-dropdown__item';
          row.setAttribute('data-search-faq', subreason);
          row.setAttribute('data-search-category', registryItem.category || '');

          row.innerHTML =
            '<span class="cf-faq-search-dropdown__question">' + registryItem.question + '</span>' +
            '<span class="cf-faq-search-dropdown__category">' + getCategoryLabel(registryItem.category) + '</span>';

          faqSearchDropdownList.appendChild(row);
        });
      }

      if (faqSearchDropdownMeta) {
        if (dedupedMatches.length > displayedMatches.length) {
          faqSearchDropdownMeta.textContent = 'Showing top ' + displayedMatches.length + ' results';
        } else {
          faqSearchDropdownMeta.textContent = 'Showing ' + displayedMatches.length + ' results';
        }
      }

      if (faqSearchDropdown) {
        faqSearchDropdown.classList.toggle('cf-hidden', displayedMatches.length === 0);
      }

      if (faqNoResults) {
        faqNoResults.classList.toggle('cf-hidden', displayedMatches.length > 0);
      }

      if (faqSearchMeta) {
        faqSearchMeta.textContent = '';
        faqSearchMeta.classList.add('cf-hidden');
      }
      return;
    }

    closeFaqSearchDropdown();
    resetHelpCentreToTopics();
    return;

    }, 120);
  });
}

  ISSUE_HELPERS.bind({
    form: form,
    issueGroups: issueGroups,
    successBox: successBox,
    summaryEl: summaryEl,
    subjectEl: subjectEl,
    issueCopy: issueCopy,
    issueToFaq: issueToFaq,
    orderNumberInput: orderNumberInput,
    productNameBlock: productNameBlock,
    productSerialBlock: productSerialBlock,
    productNameInput: productNameInput,
    productSerialInput: productSerialInput,
    faultTimingBlock: faultTimingBlock,
    faultTimingSelect: faultTimingSelect,
    returnReasonBlock: returnReasonBlock,
    returnReasonSelect: returnReasonSelect,
    addressChangeBlock: addressChangeBlock,
    updatedAddress1: updatedAddress1,
    updatedCity: updatedCity,
    updatedPostcode: updatedPostcode,
    deliveredChecksBlock: deliveredChecksBlock,
    delayedDeliveryCheckBlock: delayedDeliveryCheckBlock,
    formWrapper: formWrapper,
    detailsStep: detailsStep,
    faqSearchInput: faqSearchInput,
    FAQ_LIMIT: FAQ_LIMIT,
    FAQ_HELPERS: FAQ_HELPERS,
    faqContent: faqContent,
    setAttachmentsMode: setAttachmentsMode,
    getCategoryLabel: getCategoryLabel,
    updateDetailsPlaceholder: updateDetailsPlaceholder,
    writeDeepLink: writeDeepLink,
    syncConditionalFieldSubmission: syncConditionalFieldSubmission,
    currentCategoryRef: {
      get: function () { return currentCategory; }
    },
    isApplyingDeepLinkRef: {
      get: function () { return isApplyingDeepLink; }
    },
    setChosenReason: function (value) {
      chosenReason = value;
    },
    getFaqHighlightContext: function () {
      return {
        highlightedFaqBtn: highlightedFaqBtn,
        highlightedFaqPanel: highlightedFaqPanel
      };
    },
    getFaqOpenContext: function () {
      return {
        faqContent: faqContent,
        highlightedFaqBtn: highlightedFaqBtn,
        highlightedFaqPanel: highlightedFaqPanel
      };
    },
    setFaqHighlightState: function (state) {
      highlightedFaqBtn = state.highlightedFaqBtn;
      highlightedFaqPanel = state.highlightedFaqPanel;
    }
  });

    // SUBMIT VALIDATION
    form.addEventListener('submit', function (e) {
      if (form.dataset.cfFinalSubmit === 'true') {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      var submitBtn = form.querySelector('.cf-submit');

      if (form.dataset.cfSubmitting === 'true') {
        return;
      }

      form.dataset.cfSubmitting = 'true';
      isUploadingAttachments = true;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Uploading...';
    }

    // Must pick a specific issue in the chosen category
    var selectedIssueValue = getCurrentIssueValue();

    if (currentCategory && currentCategory !== 'warranty' && !selectedIssueValue) {
      e.preventDefault();
      resetSubmitLock();
      triggerFormErrorAnimation();
      alert('Please choose your ' + currentCategory + ' issue.');
      return;
    }

    // Require order number for all issues except "other"
    // Warranty should still require an order number even without a second-step issue
    var issueVal = getCurrentIssueValue();

    var orderRequiredCategories = ['delivery', 'orders', 'payment', 'returns'];
    var requiresOrderNumber =
      orderRequiredCategories.indexOf(currentCategory) !== -1 &&
      issueVal &&
      issueVal !== 'other';

    if (requiresOrderNumber) {
      if (!orderNumberInput || !orderNumberInput.value.trim()) {
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please enter your EG order number.');
        showDetailsStep();
        return;
      }
    }

    // Basic name + email validation
    var name = form.querySelector('input[name="contact[name]"]');
    var email = form.querySelector('input[name="contact[email]"]');

    if (!name.value.trim() || !email.value.trim()) {
      e.preventDefault();
      resetSubmitLock();
      triggerFormErrorAnimation();
      alert('Please enter your name and email.');
      showDetailsStep();
      return;
    }

    // Confirm email matches
    if (emailConfirm) {
      syncEmailConfirmValidity();
      var emailConfirmVal = emailConfirm.value.trim();
      if (!emailConfirmVal) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please confirm your email address.');
        showDetailsStep();
        return;
      }
      if (emailConfirmVal.toLowerCase() !== email.value.trim().toLowerCase()) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        emailConfirm.reportValidity();
        showDetailsStep();
        return;
      }
    }

    // Returns: extra validation for "Gear is faulty"
    if (currentCategory === 'returns' && selectedIssueValue === 'faulty_item') {
      if (!productNameInput || !productNameInput.value.trim()) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please enter the product name.');
        showDetailsStep();
        return;
      }

      if (!productSerialInput || !productSerialInput.value.trim()) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please enter the product serial number.');
        showDetailsStep();
        return;
      }

      if (!faultTimingSelect || !faultTimingSelect.value) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please choose when the fault occurred.');
        showDetailsStep();
        return;
      }
    }

    // Returns: require product name + serial number
    if (currentCategory === 'returns') {
      if (!productNameInput || !productNameInput.value.trim()) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please enter the product name.');
        showDetailsStep();
        return;
      }

      if (!productSerialInput || !productSerialInput.value.trim()) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please enter the product serial number.');
        showDetailsStep();
        return;
      }
    }


    // Extra validation for delivered no parcel / damaged items
    if (
      currentCategory === 'delivery' &&
      (selectedIssueValue === 'delivered_no_parcel' || selectedIssueValue === 'damaged_items')
    ) {
      var hasAttachment = false;
      if (attachContainer) {
        var fileInputsAll = attachContainer.querySelectorAll('input[type="file"]');
        fileInputsAll.forEach(function (fi) {
          if (fi.files && fi.files.length > 0) {
            hasAttachment = true;
          }
        });
      }

      if (!hasAttachment) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert(
          selectedIssueValue === 'damaged_items'
            ? 'Please attach photos of the damage.'
            : 'Please attach a clear photo of the signed denial of receipt form.'
        );
        showDetailsStep();
        return;
      }

    }

    // UPLOAD ATTACHMENTS TO CLOUDFLARE R2
    var fileInputs = attachContainer ? attachContainer.querySelectorAll('input[type="file"]') : [];
    var files = [];

    fileInputs.forEach(function (input) {
      if (!input.files || !input.files.length) return;

      Array.prototype.forEach.call(input.files, function (file) {
        files.push({
          file: file,
          input: input
        });
      });
    });

    if (files.length > 5) {
      e.preventDefault();
      resetSubmitLock();
      alert("You can upload a maximum of 5 files.");
      return;
    }

    if (files.length) {
      e.preventDefault();

      Promise.all(files.map(function (entry) {
        return UPLOAD_HELPERS.compressImageFile(entry.file).then(function (finalFile) {
          var fd = new FormData();
          fd.append("file", finalFile);

          return fetch("https://gear-db-proxy.onrender.com/help-centre/upload", {
            method: "POST",
            body: fd
          })
          .then(function (r) {
            if (!r.ok) {
              return r.text().then(function (txt) {
                throw new Error("Upload failed: " + txt);
              });
            }
            return r.json();
          })
          .then(function (data) {
            if (data && entry.file && entry.file.name) {
              data.name = entry.file.name;
            }
            return data;
          });
        });
      }))
      .then(function (results) {
        var uploadedFiles = results
          .map(function (data) {
            if (!data || !data.url) return null;
            return {
              url: data.url,
              name: data.name || ''
            };
          })
          .filter(Boolean);

        if (!uploadedFiles.length) {
          throw new Error("No upload URLs returned.");
        }

        UPLOAD_HELPERS.syncUploadedAttachmentFields(form, uploadedFiles);

        fileInputs.forEach(function (input) {
          input.value = "";
          input.disabled = true;
        });

        form.dataset.cfFinalSubmit = 'true';
        isFinalNativeSubmit = true;
        form.submit();
      })
      .catch(function (err) {
        console.error(err);
        resetSubmitLock();

        var msg = (err && err.message) ? err.message : String(err || 'Unknown upload error');
        alert("Attachment upload failed:\n\n" + msg);
      });

      return;
    }
      form.dataset.cfFinalSubmit = 'true';
      isFinalNativeSubmit = true;
      form.submit();
  }, true);

  UPLOAD_HELPERS.bindPreviewUi(attachContainer);

  if (emailInput && emailConfirm) {
    emailInput.addEventListener('input', syncEmailConfirmValidity);
    emailConfirm.addEventListener('input', syncEmailConfirmValidity);
    emailConfirm.addEventListener('blur', syncEmailConfirmValidity);
  }
  
// --- ON INITIAL PAGE LOAD: keep FAQ results hidden until search ---
var allSubgroups = form.querySelectorAll('#faqResults .cf-subgroup, #contactFormWrapper .cf-subgroup');

allSubgroups.forEach(function (sg) {
  sg.classList.add('cf-hidden');
});

if (faqResultsLabel) faqResultsLabel.classList.add('cf-hidden');
if (faqNoResults) faqNoResults.classList.add('cf-hidden');
if (faqSearchMeta) {
  faqSearchMeta.textContent = '';
  faqSearchMeta.classList.add('cf-hidden');
}
if (faqResults) faqResults.classList.add('cf-hidden');
if (faqContactTrigger) faqContactTrigger.classList.add('cf-hidden');

document.addEventListener('click', function (e) {
  if (!faqSearchDropdown || faqSearchDropdown.classList.contains('cf-hidden')) return;
  if (faqSearchArea && faqSearchArea.contains(e.target)) return;

  closeFaqSearchDropdown();
});

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;

  closeFaqSearchDropdown();
});

window.EG_HELP_CENTRE_ACCORDION = {
  sync: function (panel) {
    if (!panel || !panel.classList.contains('is-open')) return;

    panel.style.maxHeight = (panel.scrollHeight + 20) + 'px';
  },

  open: function (panel) {
    if (!panel) return;

    panel.classList.add('is-open');
    panel.style.visibility = 'visible';
    panel.style.maxHeight = panel.scrollHeight + 'px';

    requestAnimationFrame(function () {
      window.EG_HELP_CENTRE_ACCORDION.sync(panel);
    });

    setTimeout(function () {
      window.EG_HELP_CENTRE_ACCORDION.sync(panel);
    }, 50);
  },

  close: function (panel) {
    if (!panel) return;

    panel.style.maxHeight = (panel.scrollHeight + 20) + 'px';
    panel.offsetHeight;

    panel.classList.remove('is-open');
    panel.style.maxHeight = '0px';

    function handleCloseEnd(e) {
      if (e.propertyName !== 'max-height') return;
      panel.removeEventListener('transitionend', handleCloseEnd);

      if (!panel.classList.contains('is-open')) {
        panel.style.visibility = 'hidden';
      }
    }

    panel.removeEventListener('transitionend', handleCloseEnd);
    panel.addEventListener('transitionend', handleCloseEnd);
  }
};

form.querySelectorAll('.cf-info-toggle').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var content = btn.nextElementSibling;
    if (!content || !content.classList.contains('cf-info-content')) return;

    var isOpen = btn.getAttribute('aria-expanded') === 'true';

    form.querySelectorAll('.cf-info-toggle').forEach(function (otherBtn) {
      if (otherBtn === btn) return;

      otherBtn.setAttribute('aria-expanded', 'false');

      var otherContent = otherBtn.nextElementSibling;
      if (otherContent && otherContent.classList.contains('cf-info-content')) {
        window.EG_HELP_CENTRE_ACCORDION.close(otherContent);
      }
    });

    if (isOpen) {
      btn.setAttribute('aria-expanded', 'false');
      window.EG_HELP_CENTRE_ACCORDION.close(content);
    } else {
      btn.setAttribute('aria-expanded', 'true');
      window.EG_HELP_CENTRE_ACCORDION.open(content);
    }
  });
});

window.addEventListener('resize', function () {
  document.querySelectorAll('.cf-info-content.is-open').forEach(function (panel) {
    window.EG_HELP_CENTRE_ACCORDION.sync(panel);
  });
});

function initInfoPanels(scope) {
  var root = scope || form;

  root.querySelectorAll('.cf-info-toggle').forEach(function (btn) {
    var content = btn.nextElementSibling;
    if (!content || !content.classList.contains('cf-info-content')) return;

    if (btn.getAttribute('aria-expanded') === 'true' || content.classList.contains('is-open')) {
      content.classList.add('is-open');
      content.style.visibility = 'visible';
      content.style.maxHeight = 'none';

      requestAnimationFrame(function () {
        window.EG_HELP_CENTRE_ACCORDION.sync(content);
      });

      setTimeout(function () {
        if (content.classList.contains('is-open')) {
          window.EG_HELP_CENTRE_ACCORDION.sync(content);
        }
      }, 50);
    } else {
      content.classList.remove('is-open');
      content.style.maxHeight = '0px';
      content.style.visibility = 'hidden';
    }
  });
}

initInfoPanels();

// Sync FAQ buttons with registry (source of truth)
form.querySelectorAll('.cf-reason').forEach(function (btn) {
  var subreason = btn.getAttribute('data-subreason');
  var item = getFaqRegistryItem(subreason);

  if (!item) {
    console.warn('Missing FAQ registry item:', subreason);
    return;
  }

  // Update visible question text
  var textEl = btn.querySelector('.cf-faq-question-text');
  if (textEl && item.question) {
    textEl.textContent = item.question;
  }

  // Update subject attribute
  if (item.subject) {
    btn.setAttribute('data-subject', item.subject);
  }
});

if (FAQ_HELPERS.buildFaqCorpusCache) {
  FAQ_HELPERS.buildFaqCorpusCache(form, FAQ_SEARCH_KEYWORDS);
}

applyDeepLinkFromUrl();
setAttachmentsMode('hide');
syncConditionalFieldSubmission();
});
